<template>
    <div class="userlist">
        <div style="padding: 10px 0;display: flex;justify-content: space-between;">
            <div>
                <el-button style="color: #000" @click="adduser" v-if="isadd">新增</el-button>
                <el-button style="color: #000" @click="delAll">批量删除</el-button>
            </div>
            　　　　　　　　
            <div class="screen_item">
                <el-input v-model="params.vc_login" placeholder="姓名/登录名" clearable
                          prefix-icon="el-icon-search" style="width: 230px;">

                </el-input>
                <span @click="sercher" style="" class="searchuser">搜索</span>
            </div>
        </div>
        <el-table
                border
                ref="multipleTable"
                :data="userlist"
                tooltip-effect="dark"
                style="width: 100%; "
                :header-cell-style="{'text-align':'center',background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange" v-loading="user_loading">
            <el-table-column
                    align="center"
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="i_id"
                    align="center"
                    label="用户ID"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_name"
                    align="center"
                    label="姓名"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_login"
                    align="center"
                    label="登录名">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_corpname"
                    label="所在公司">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_state"
                    label="用户状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.i_state">正常</div>
                    <div v-if="!scope.row.i_state">禁用</div>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="rlist"
                    label="角色">
                <template slot-scope="scope">
                    <div>
                        {{change(scope.row.rlist)}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="操作">
                <template slot-scope="scope">
                    <div class="done" style="text-align: center;">
                        <div @click="handleEdit(scope.row)">编辑 <span>|</span></div>
<!--                        <div @click="handleReset(scope.row)">重置密码 <span>|</span></div>-->
                        <div @click="handleDelete( scope.row)">删除</div>

                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;padding: 20px 0">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="totalList" :page-size="pageSize" >
            </el-pagination>
        </div>

        <!-- 新增时候的弹出层 -->
        <el-dialog title="新增用户" :visible.sync="dialogFormVisibleadd" @close="dialogClose('formref')"
                   :close-on-click-modal="false" width="30%">
            <el-form :model="formuser" ref="formref" :rules="rules" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="vc_name">
                    <el-input v-model="formuser.vc_name" style="width: 90%"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="vc_login">
                    <el-input v-model="formuser.vc_login" style="width: 90%"></el-input>
                </el-form-item>

                <el-form-item label="手机号" prop="vc_mobile">
                    <el-input v-model="formuser.vc_mobile" style="width: 90%"></el-input>
                </el-form-item>
                <el-form-item label="角色集合" prop="roleList">
                    <el-select v-model="formuser.roleList" multiple placeholder="请选择角色" style="width: 90%">
                        <el-option
                                v-for="item in options"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="语种" prop="language">
                    <el-select v-model="formuser.language" placeholder="请选择语种" style="width: 90%">
                        <el-option
                                v-for="item in languagelist"
                                :key="item.value"
                                :label="item.value"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisibleadd = false">取 消</el-button>
                <el-button type="primary" @click="saveadd('formref')" :disabled="isaddbtn">保存</el-button>
            </div>
        </el-dialog>

        <!-- 编辑时候的弹出层 -->
        <el-dialog title="编辑用户" :visible.sync="dialogFormVisibleedit" @close="dialogCloseedit('formedit')"
                   :close-on-click-modal="false" width="30%" height="300px">
            <el-form :model="formedit" ref="formedit" :rules="rulesedit" label-width="100px" class="demo-ruleForm" v-loading="detail_loading">
                <el-form-item label="姓名" >
                    <el-input v-model="formedit.vc_name" style="width: 90%" disabled></el-input>
                </el-form-item>
                <el-form-item label="登录账号" >
                    <el-input v-model="formedit.vc_login" style="width: 90%" disabled></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="formedit.vc_mobile" style="width: 90%" disabled></el-input>
                </el-form-item>

                <el-form-item label="角色集合" prop="roleList">
                    <el-select v-model="formedit.roleList" multiple placeholder="请选择角色" style="width: 90%" :disabled="isdisabled">
                        <el-option
                                v-for="item in optionsedit"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语种">
                    <el-select v-model="formedit.language" placeholder="请选择语种" style="width: 90%" disabled>
                        <el-option
                                v-for="item in languagelist"
                                :key="item.value"
                                :label="item.value"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作">
                    <el-col :span="10">
                        <el-checkbox v-model="formedit.i_state">是否有效</el-checkbox>
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisibleedit = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('formedit')" :disabled="iseditbtn">保存</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";

    export default {
        name: "userlist",
        data() {
            return {
                user_loading:false,
                isadd: false,
                isaddbtn:false,
                currentPage:1,
                iseditbtn:false,
                isdisabled:false,
                userlist: [],
                pageSize: 4,
                totalList: 0,
                pageIndex: 1,
                detail_loading:false,
                multipleSelection: [],
                dialogFormVisibleadd: false,
                dialogFormVisibleedit: false,
                typerole: '',
                is_ustate: '',
                mid: '',
                role_old: '',
                e_id: '',
                delarr: [],//存放删除的数据
                params: {
                    vc_login: ""
                },
                formuser: {
                    vc_name: "",
                    vc_login: "",
                    vc_mobile: "",
                    language: '',
                    roleList: [],
                },
                formedit: {
                    vc_name: "",
                    vc_login: "",
                    i_state: [],
                    vc_mobile: "",
                    language: "",
                    roleList: [],
                },
                languagelist: [{
                    value: 'zh_cn'
                }, {
                    value: 'en_us'
                }, {
                    value: 'ru_ru'
                },],
                options: "",
                optionsedit: '',
                optionsCor: '',
                rules: {
                    vc_name: [
                        {required: true, message: '姓名不能为空', trigger: 'blur'},
                    ],
                    vc_login: [
                        {required: true, message: '登录账号不能为空', trigger: 'blur'},
                    ],
                    // Vc_pwd: [
                    //     {required: true, message: '密码不能为空', trigger: 'blur'},
                    //     {pattern:/^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,})$/, message: '密码同时包含数字,字母,长度为 6 - 30位'}
                    //     ],
                    vc_mobile: [
                        {required: true, message: '手机号不能为空'},
                        {
                            type: 'number',
                            message: '手机号格式不正确',
                            trigger: 'blur',
                            transform(value) {
                                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                                if (!phonereg.test(value)) {
                                    return false
                                } else {
                                    return Number(value)
                                }
                            }
                        }
                    ],
                    roleList: [
                        {required: true, message: '请选择角色', trigger: 'change'}
                    ],
                    language: [
                        {required: true, message: '请选择语种', trigger: 'change'}
                    ],

                },

                rulesedit: {
                    roleList: [
                        {required: true, message: '请选择角色', trigger: 'change'}
                    ],
                },
            }
        },
        mounted() {
            this.getlist();
            if (sessionStorage.getItem("userType") == 1 || sessionStorage.getItem("userType") == 3) {
                this.isadd = true;
                this.isdisabled=false;
            } else {
                this.isadd = false;
                this.isdisabled = true;
            }
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            //获取table
            async getlist() {
                this.user_loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    i_pid: 0,
                    pageStart: (this.pageIndex - 1) * this.pageSize,
                    pageSize: this.pageSize,
                    condition: this.params.vc_login == "" ? "" : this.params.vc_login,
                    vc_language: "zh_cn",
                };

                let res = await API.userlist(param);
                if (res.code == 1) {
                    this.user_loading=false;
                    this.userlist = res.userList;
                    this.typerole = res.userList.i_type;
                    this.totalList = res.count;
                } else if (res.code == -2) {
                    this.user_loading=false;
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.user_loading=false;
                    this.$message.error(res.message);
                }

            },
            //搜索
            sercher() {
                this.pageIndex=1;
                this.currentPage=1;
                this.getlist();
            },

            //获取当前页数据
            pageCurrentChange(val) {
                this.pageIndex = val;
                this.getlist();
            },
            //表格角色转换
            change(rlist) {
                var newrlist = []
                for (var i = 0; i < rlist.length; i++) {
                    newrlist.push(rlist[i].vc_name)
                }
                return newrlist.join(",")
            },
            //获取Rolelist
            async getRolelist() {
                let param = {
                    i_id: 0,
                    i_type: this.typerole,
                };
                let res = await API.Rolelist(param);
                if (res.code == 1) {
                    this.options = res.roleList;
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //获取editRolelist
            async geteditRolelist() {
                let param = {
                    i_id: this.e_id,
                    i_type: this.typerole,
                };
                let res = await API.Rolelist(param);
                if (res.code == 1) {
                    this.optionsedit = res.roleList;
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //新增
            adduser() {
                this.dialogFormVisibleadd = true;
                this.isaddbtn=false;
                this.getRolelist();
            },
            //新增保存
            async saveadd(ref) {
                // 校验数据
                let valid = await this.$formRulesValidate({ref, example: this});
                if (!valid) {
                    return;
                }
                this.isaddbtn=true;
                // if (this.formuser.i_state.length !== 0) {
                //     this.is_ustate = 1
                // } else {
                //     this.is_ustate = 0
                // }
                var Arr = this.formuser.roleList;
                var min;
                for (var i = 0; i < Arr.length; i++) {
                    for (var j = i; j < Arr.length; j++) {
                        if (Arr[i] > Arr[j]) {
                            min = Arr[j];
                            Arr[j] = Arr[i];
                            Arr[i] = min;
                        }
                    }
                }
                let params = {
                    vc_name: this.formuser.vc_name,
                    vc_login: this.formuser.vc_login,
                    i_state: 1,
                    roleList: Arr,
                    vc_mobile: this.formuser.vc_mobile,
                    vc_language: this.formuser.language,
                    i_lruid: sessionStorage.getItem('userid'),
                };
                let res = await API.saveUser(params);
                if (res.code == 1) {
                    this.isaddbtn=false;
                    this.$message.success(res.message);
                    this.getlist();
                } else if (res.code == -2) {
                    this.isaddbtn=false;
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.isaddbtn=false;
                    this.user_loading=false;
                    this.$message.error(res.message);
                }
                this.dialogFormVisibleadd = false;
            },

            //编辑
            async handleEdit(row) {

                this.detail_loading=true;
                this.iseditbtn=false;
                this.geteditRolelist();
                this.dialogFormVisibleedit = true
                this.e_id = row.i_id
                let params = {
                    i_id: row.i_id,
                };
                let res = await API.userinfo(params);
                var userinfo = res.userInfo
                if (res.code == 1) {
                    this.detail_loading=false;
                    this.formedit.vc_name = userinfo.vc_name
                    this.formedit.vc_login = userinfo.vc_login
                    this.formedit.vc_mobile = userinfo.vc_mobile
                    // if (userinfo.i_gender == 1) {
                    //     this.formedit.i_gender = 1
                    // } else {
                    //     this.formedit.i_gender = 0
                    // }

                    if (userinfo.i_state == 1) {
                        this.formedit.i_state = true;
                    } else {
                        this.formedit.i_state = false;
                    }
                    var newArr = [];
                    var rlist = userinfo.rlist;
                    for (var i = 0; i < rlist.length; i++) {
                        newArr.push(rlist[i].i_id)
                    }
                    this.formedit.roleList = newArr;
                    this.role_old = newArr
                    this.formedit.language = userinfo.vc_language
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
            },

            //编辑保存
            async saveEdit(ref) {
                let valid = await this.$formRulesValidate({ref, example: this});
                if (!valid) {
                    return
                }
                this.iseditbtn=true;
                if (this.formedit.i_state == true) {
                    this.is_ustate = 1
                } else {
                    this.is_ustate = 0
                }
                if (JSON.stringify(this.role_old) == JSON.stringify(this.formedit.roleList)) {
                    let params = {
                        i_id: this.e_id,
                        roleList_old: this.role_old,
                        roleList_new: this.role_old,
                        i_state: this.is_ustate,
                    };
                    let res = await API.updateUser(params);
                    if (res.code == 1) {
                        this.iseditbtn=false;
                        this.$message.success(res.message);
                        this.getlist();
                    } else if (res.code == -2) {
                        this.iseditbtn=false;
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    } else {
                        this.iseditbtn=false;
                        this.$message.error(res.message);
                    }
                } else {
                    var Arr = this.formedit.roleList;
                    var min;
                    for (var i = 0; i < Arr.length; i++) {
                        for (var j = i; j < Arr.length; j++) {
                            if (Arr[i] > Arr[j]) {
                                min = Arr[j];
                                Arr[j] = Arr[i];
                                Arr[i] = min;
                            }
                        }
                    }
                    let params = {
                        i_id: this.e_id,
                        roleList_old: this.role_old,
                        roleList_new: Arr,
                         i_state: this.is_ustate,
                    };
                    let res = await API.updateUser(params);
                    if (res.code == 1) {
                        this.iseditbtn=false;
                        this.$message.success(res.message);
                        this.getlist();
                    } else if (res.code == -2) {
                        this.iseditbtn=false;
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    } else {
                        this.iseditbtn=false;
                        this.$message.error(res.message);
                    }
                }


                this.dialogFormVisibleedit = false;
            },
            // 重置密码
            // handleReset(row) {
            //     this.$confirm(
            //         "确定重置密码吗！",
            //         "提示！",
            //         {
            //             confirmButtonText: "确定",
            //             cancelButtonText: "取消",
            //             type: "warning",
            //         }
            //     ).then(async () => {
            //         let params = {
            //             i_id: row.id,
            //             vc_login: row.vc_login
            //         }
            //         let res = await API.resetPwd(params);
            //         if (res.code == 1) {
            //             this.$message.success(res.message);
            //             this.getlist();
            //         } else if (res.code == -2) {
            //             this.$router.push('/login')
            //             this.$message.error(res.message);
            //         } else {
            //             this.$message.error(res.message);
            //         }
            //     }).catch(() => {
            //     });
            // },
            // 删除
            handleDelete(row) {
                var id_list = new Array()
                id_list.push(row.i_id)
                this.$confirm(
                    '确定删除'+ row.vc_name+'用户吗?',
                    "提示！",
                    {
                        confirmButtonText: "确定删除",
                        cancelButtonText: "取消删除",
                        type: "warning",
                    }
                ).then(async () => {
                    let params = {
                        idList: id_list,
                    }
                    let res = await API.del(params);
                    if (res.code == 1) {
                        this.$message.success("删除成功");
                        this.getlist();
                    } else if (res.code == -2) {
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(() => {
                });
            },


            //批量删除
            delAll() {
                const length = this.multipleSelection.length;
                for (let i = 0; i < length; i++) {
                    this.delarr.push(this.multipleSelection[i].i_id)
                    this.$confirm(
                        "确定删除选中的"+length+"条数据吗，将会删除与此数据关联的所有数据！请谨慎操作！！！",
                        "提示！",
                        {
                            confirmButtonText: "确定删除",
                            cancelButtonText: "取消删除",
                            type: "warning",
                        }
                    )
                        .then(async () => {
                            let params = {
                                idList: this.delarr,
                            }
                            let res = await API.del(params);
                            if (res.code == 1) {
                                this.$message.success('删除成功');
                                this.getlist();
                            } else if (res.code == -2) {
                                this.$router.push('/login')
                                this.$message.error(res.message);
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                        .catch(() => {
                        });
                }
            },

            //移除校验结果并重置字段值
            dialogClose(formName) {
                this.$refs[formName].resetFields();
                this.formuser.i_state = false;
                this.formuser.i_gender = false;
            },
            dialogCloseedit(formName) {
                this.$refs[formName].resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }
        }

    }
</script>
<style lang="scss">
.userlist{

    .el-dialog{
        top:50%;
        transform: translate(0,-50%);
        margin-top: 0px!important;
    }
}
.screen_item{
    display: flex;
    width: 280px;
    .el-input__inner{
        border-top-left-radius: 46px;
        border-bottom-left-radius: 46px;

    }
}
.searchuser{
    background: #3e82e8;
    color: #fff;
    height: 40px;
    line-height: 40px;
    width: 80px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    border-radius: 0 27px 27px 0;
}
</style>
